<template>

    <SubHeader title="Liste des Notifications" :breads="[{ name: 'Notifications' }]" :action="{}" />


    <div class="row">
        <div class="col-5">
            <div class="card">
                <div class="card-header">
                    <span>Liste des notifications</span>
                </div>
                <div class="card-body">
                    <div class="row ">
                        <div class="col-lg-12">
                            <!-- Alert -->
                        
                            <!-- End Alert -->

                            <!-- Step -->
                            <ul class="step">
                                <!-- Step Item -->
                                <li class="step-item">
                                    <div class="step-content-wrapper">
                                        <small class="step-divider">Aujourd'hui</small>
                                    </div>
                                </li>
                              

                                <!-- Step Item -->
                                <li class="step-item" v-for="(notification, i) in notifications" :key="i">
                                    <div class="step-content-wrapper" >
                                        <span class="step-icon step-icon-soft-dark">{{notification.title[0] ?? 'N'}}</span>

                                        <div class="step-content">
                                            <h5 class="mb-1">{{notification.title}}</h5>

                                            <p class="fs-5 mb-1">{{notification.body}}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                
                            </ul>
                            <!-- End Step -->

                            <!-- Footer -->
                            <div class="d-grid">
                                <a class="btn btn-white" href="javascript:;">
                                    <i class="bi-arrow-clockwise me-1"></i> Voir plus
                                </a>
                            </div>
                            <!-- End Footer -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapFields } from "vuex-map-fields";

export default {
    name: "NotificationList",
    components: {
        SubHeader
    },
    computed:{
        ...mapFields("notification/list", {
            notifications:"items",
            isLoading:'isLaoding',
            isReading:"isReading"
        }),
    }

}
</script>
